import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Col,
  Input,
  Row,
  Select,
  Slider,
  Tooltip,
  InputNumber, Button, message,
} from 'antd';
import Icon, { InfoCircleOutlined, CopyOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Form } from '@ant-design/compatible';
import { getPoiGroupsAction } from '../../../../actions/AppCms/PoiGroupActions';
import { getObjectNumListAction } from '../../../../actions/SpecActions/ObjectNumActions';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';
import checkEnabledFeatures from '../../../../components/Authorization/Feature';
import GlbUploader from '../../../../nextgen/components/image-upload/GlbUploader';
import MediaUploader from '../../../../nextgen/components/image-upload/MediaUploader';
import '../Style.css';

import { defaultIcon } from '../Constants';
import OldImageUploader from '../../../../firebase/OldImageUploader';
import { useTranslation } from 'react-i18next';

const BluetoothSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="132.000000pt"
    height="130.000000pt"
    viewBox="0 0 132.000000 130.000000"
    preserveAspectRatio="xMidYMid meet"
    id="bluetooth"
  >
    <g
      transform="translate(0.000000,130.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M960 961 l0 -223 -86 77 -86 78 -23 -29 -24 -29 105 -100 105 -100
-105 -105 -106 -104 27 -28 27 -28 83 82 83 83 0 -210 0 -210 162 162 162 162
-74 69 c-41 38 -91 83 -110 100 l-35 31 110 111 110 110 -163 163 -162 162 0
-224z m147 -168 l-67 -68 0 135 0 135 67 -68 68 -67 -68 -67z m25 -320 l38
-39 -65 -64 -65 -64 0 122 0 123 28 -19 c15 -11 44 -38 64 -59z"
      />
      <path
        d="M276 1066 c-55 -59 -102 -139 -134 -228 -23 -65 -26 -87 -26 -203 0
-114 4 -139 26 -203 32 -89 79 -169 135 -230 40 -43 43 -44 65 -29 13 8 23 21
22 29 -1 7 -23 42 -50 78 -88 116 -124 219 -124 355 0 134 43 259 124 359 59
72 60 75 40 97 -24 27 -32 25 -78 -25z"
      />
      <path
        d="M433 965 c-33 -23 -90 -115 -113 -186 -18 -53 -21 -81 -18 -164 3
-87 8 -109 35 -167 52 -110 102 -166 137 -152 32 12 28 42 -13 94 -119 150
-117 347 5 497 38 47 40 55 18 77 -19 20 -24 20 -51 1z"
      />
      <path
        d="M535 826 c-49 -49 -70 -105 -70 -191 0 -70 4 -87 30 -134 32 -58 63
-85 88 -75 31 11 29 41 -5 89 -30 42 -33 53 -33 120 0 67 3 78 33 119 37 53
38 59 16 80 -21 21 -31 20 -59 -8z"
      />
    </g>
  </svg>
);
const BluetoothIcon = () => <Icon component={BluetoothSvg} />;

const { Option } = Select;

let markerPOI = null;
let map = null;

const General = ({ reportData, form, submit }) => {
  const { t } = useTranslation();

  const [featuredImage, setFeaturedImage] = useState([]);
  const [otherImages, setOtherImages] = useState([]);
  const [referenceImages, setReferenceImages] = useState([]);
  const [video, setVideo] = useState([]);
  const [model3d, setModel3d] = useState([]);

  useEffect(() => {
    if (reportData?.data?.featuredImage) {
      setFeaturedImage([reportData.data.featuredImage]);
    }
    if (reportData?.data?.imageList) {
      setOtherImages(reportData?.data?.imageList);
    }
    if (reportData?.data?.referenceImageList) {
      setReferenceImages(reportData?.data?.referenceImageList);
    }
    setVideo(reportData?.data?.videoFiles || []);
    setModel3d(reportData?.data?.glbFiles || []);
  }, [reportData]);


  const dispatch = useDispatch();

  const { objectNumList, poiGroups } = useSelector(store => ({
    objectNumList: store.objectNumReducer.objectNumList,
    poiGroups: store.poiGroupReducer.poiGroups,
  }));

  const addMarker = e => {
    if (markerPOI) {
      // check
      map.removeLayer(markerPOI); // remove
    }
    markerPOI = new L.Marker(e.latlng, { icon: defaultIcon }).addTo(map); // set
    const coordinates = markerPOI.getLatLng();

    form.setFieldsValue({
      latitude: coordinates.lat,
      longitude: coordinates.lng,
    });
  };

  useEffect(() => {
    map = L.map('map').setView([35.9375, 14.3754], 4);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 12,
    }).addTo(map);

    map.on('click', addMarker);
  }, []);

  useEffect(() => {
    if (
      reportData &&
      reportData.data &&
      reportData.data.location &&
      reportData.data.location.latitude &&
      reportData.data.location.longitude
    ) {
      const markerLatLng = new L.LatLng(
        reportData.data.location.latitude,
        reportData.data.location.longitude,
      );
      const latLng = {
        latlng: markerLatLng,
      };
      addMarker(latLng);
    }
  }, [reportData]);

  useEffect(() => {
    if (map) {
      if (form.getFieldsValue().latitude && form.getFieldsValue().longitude) {
        const markerLatLng = new L.LatLng(
          form.getFieldsValue().latitude,
          form.getFieldsValue().longitude,
        );
        const latLng = {
          latlng: markerLatLng,
        };
        addMarker(latLng);
        map.panTo(markerLatLng);
      }
    }
  }, [map, form.getFieldsValue().latitude, form.getFieldsValue().longitude]);

  useEffect(() => {
    dispatch(getPoiGroupsAction());
    dispatch(getObjectNumListAction());

  }, []);

  useEffect(() => {
    form.setFieldsValue({
      featuredImage: featuredImage,
    });
  }, [featuredImage])

  useEffect(() => {
    form.setFieldsValue({
      imageList: otherImages,
    });
  }, [otherImages]);

  useEffect(() => {
    form.setFieldsValue({
      referenceImageList: referenceImages,
    });
  }, [referenceImages]);

  useEffect(() => {
    form.setFieldsValue({ videoFiles: video });
  }, [video]);

  useEffect(() => {
    form.setFieldsValue({ glbFiles: model3d });
  }, [model3d]);

  const onCopyLocation = () => {
    const lat = form.getFieldValue("latitude");
    const long = form.getFieldValue("longitude");
    if (lat && long) {
      navigator.clipboard.writeText(lat + "," + long);
    }
    message.info(t('appCms.poi.coordinatesCopied'))
  }

  const { getFieldDecorator } = form;

  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');
  return (
    (<div>
      <Row>
        <Col span={13}>
          <Card bordered={false}>
            <Form.Item label={t('appCms.poi.poiGroup')}>
              {getFieldDecorator('group', {
                rules: [
                  {
                    required: true,
                    message: t('appCms.poi.poiGroupRequired'),
                  },
                ],
                initialValue:
                  reportData &&
                    reportData.data.group &&
                    reportData.data.group.id
                    ? reportData.data.group.id
                    : undefined,
              })(
                <Select
                  allowClear
                  showSearch
                  filterOption
                  optionFilterProp="children"
                  // onChange={val => this.handleObjectNumSelection(val)}
                  disabled={disable}
                >
                  {poiGroups.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.title}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>

            {reportData ? (
              <Form.Item label={t('appCms.poi.beaconLabel')}>
                {getFieldDecorator('beacon', {
                  rules: [],
                  initialValue:
                    reportData && reportData.data.beaconId
                      ? reportData.data.beaconId
                      : undefined,
                })(<Input disabled />)}
              </Form.Item>
            ) : (
              ''
            )}

            {/* <div style={{ }}>  */}
            <Form.Item
              label={
                <span>
                  {t('appCms.poi.beaconDetectionRange')}&nbsp;
                  <Tooltip
                    title={
                      <>
                        <span>
                          {t('appCms.poi.beaconTooltipText')}{' '}
                        </span>
                        <br />
                        <br />
                        <table className="beacon-detection-table">
                          <tr>
                            <th>{t('appCms.poi.dbaRange')}</th>
                            <th>{t('appCms.poi.meters')}</th>
                          </tr>
                          <tr>
                            <td>-76dBa to -85dBa</td>
                            <td>12 ~ 18M</td>
                          </tr>
                          <tr>
                            <td>-73dBa to -76dBa</td>
                            <td>6 ~ 12M</td>
                          </tr>
                          <tr>
                            <td>-70dBa to -73dBa</td>
                            <td>2 ~ 6M</td>
                          </tr>
                          <tr>
                            <td>-50dBa to -70dBa </td>
                            <td>1 ~ 2M</td>
                          </tr>
                          <tr>
                            <td>-30dBa to -50dBa</td>
                            <td>0 ~ 1M</td>
                          </tr>
                        </table>
                      </>
                    }
                  >
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('beaconSensitivityRange', {
                rules: [],
                initialValue:
                  reportData && reportData.data.beaconSensitivityRange
                    ? [
                      reportData.data.beaconSensitivityRange.min,
                      reportData.data.beaconSensitivityRange.max,
                    ]
                    : undefined,
              })(
                <Slider
                  style={{
                    maxWidth: '100%',
                    // width: '250px',
                    // display: 'inline-block',
                  }}
                  range={{ draggableTrack: true }}
                  marks={{
                    '-300': t('appCms.poi.furthest'),
                    '-20': (
                      <div style={{ display: 'flex' }}>
                        {' '}
                        {t('appCms.poi.closest')}{' '}
                        <BluetoothIcon
                          style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'right',
                          }}
                        />
                      </div>
                    ),
                  }}
                  defaultValue={[-80, -20]}
                  min={-300}
                  max={-20}
                  disabled={disable}
                />,
              )}
            </Form.Item>
            <Form.Item label={t('appCms.poi.youtubeLink')}>
              {getFieldDecorator('youtubeLink', {
                rules: [],
                initialValue:
                  reportData && reportData.data.youtubeLink
                    ? reportData.data.youtubeLink
                    : undefined,
              })(<Input disabled={disable} />)}
            </Form.Item>
            <Form.Item label={t('appCms.poi.addressIdentifier')}>
              {getFieldDecorator('address', {
                rules: [
                  {
                    required: true,
                    message: t('appCms.poi.addressRequired'),
                  },
                ],
                initialValue:
                  reportData &&
                    reportData.data.location &&
                    reportData.data.location.location
                    ? reportData.data.location.location
                    : undefined,
              })(<Input disabled={disable} />)}
            </Form.Item>
            <Form.Item label={<>
              {t('appCms.poi.position')}
              <Button onClick={onCopyLocation} type="link"><CopyOutlined /></Button>
            </>}>
              {getFieldDecorator('location', {
              })(
                <>
                  <div id="map" style={{ height: '250px' }} />
                </>,
              )}
            </Form.Item>

            <Form.Item label={t('appCms.poi.latitude')}>
              {getFieldDecorator('latitude', {
                rules: [
                  {
                    required: true,
                    message: t('appCms.poi.latitudeRequired'),
                  },
                ],
                initialValue:
                  reportData && reportData.data.location.latitude
                    ? reportData.data.location.latitude
                    : undefined,
              })(<InputNumber min={-90} max={90} style={{ width: '100%' }} />)}
            </Form.Item>
            <Form.Item label={t('appCms.poi.longitude')}>
              {getFieldDecorator('longitude', {
                rules: [
                  {
                    required: true,
                    message: t('appCms.poi.longitudeRequired'),
                  },
                ],
                initialValue:
                  reportData && reportData.data.location.longitude
                    ? reportData.data.location.longitude
                    : undefined,
              })(
                <InputNumber min={-180} max={180} style={{ width: '100%' }} />,
              )}
            </Form.Item>
            <Form.Item label={t('appCms.poi.externalReference')}>
              {getFieldDecorator('externalReference', {
                rules: [],
                initialValue:
                  reportData && reportData.data.externalReference
                    ? reportData.data.externalReference
                    : undefined,
              })(<Input disabled={disable} />)}
            </Form.Item>
            {checkEnabledFeatures(value, 'Item-Cataloging') && (
              <Form.Item label={t('appCms.poi.linkedItems')}>
                {getFieldDecorator('linkedItemIds', {
                  rules: [],
                  initialValue:
                    reportData && reportData.data.linkedItemIds
                      ? reportData.data.linkedItemIds
                      : undefined,
                })(
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    filterOption
                    optionFilterProp="children"
                    // onChange={val => this.handleObjectNumSelection(val)}
                    disabled={disable}
                    style={{ width: '100%' }}
                  >
                    {objectNumList.map(item => (
                      <Option key={item.id} value={item.id}>
                        {item.objectName}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            )}
          </Card>
        </Col>
        <Col span={11}>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('featuredImage', {
                valuePropName: 'file',
              })(
                <Card title={t('appCms.poi.featuredImage')}>
                  <Row justify="center">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setFeaturedImage}
                      fileList={featuredImage}
                      maxCount={1}
                      storageFolder='poi-featured-images'
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>

          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('imageList', {
                valuePropName: 'file',
              })(
                <Card title={t('appCms.poi.otherImages')}>
                  <Row justify="center">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setOtherImages}
                      fileList={otherImages}
                      maxCount={20}
                      multiple={true}
                      storageFolder='poi-images'
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>

          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('referenceImageList', {
                valuePropName: 'file',
              })(
                <Card title={t('appCms.poi.referenceImages')}>
                  <Row justify="center">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setReferenceImages}
                      fileList={referenceImages}
                      maxCount={20}
                      multiple={true}
                      storageFolder='poi-ref-images'
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>

          <Card bordered={false}>
            <Form.Item wrapperCol={{ xs: { span: 24 } }} style={{ display: 'flex' }}>
              {getFieldDecorator('glbFiles',{ valuePropName: 'file' })(
                <Card title={t('appCms.poi.model3d')}>
                  <Row justify="center">
                    <GlbUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      storageFolder={
                        window.location.hostname.split('.')[0] + '/poiModel3d-files'
                      }
                      fileList={model3d}
                      setFileList={setModel3d}
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>

          <Card bordered={false}>
            <Form.Item wrapperCol={{ xs: { span: 24 } }} style={{ display: 'flex' }}>
              {getFieldDecorator('videoFiles', { valuePropName: 'file' })(
                <Card title={t('appCms.poi.video')}>
                  <Row justify="center">
                    <MediaUploader
                      kind="video"
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      storageFolder={
                        window.location.hostname.split('.')[0] + '/poiVideo-files'
                      }
                      fileList={video}
                      setFileList={setVideo}
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>)
  );
};

General.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  reportData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps({ objectNumReducer, poiGroupReducer }) {
  const { objectNumList } = objectNumReducer;
  const { poiGroups } = poiGroupReducer;
  return {
    objectNumList,
    poiGroups,
  };
}

export default connect(mapStateToProps, {
  getPoiGroupsAction,
  getObjectNumListAction,
})(General);
